<template>
	<div class="loading">
		<!-- 状态值 -->
		<div class="status-text" v-if="statusText">
			<img class="icon-rorate" src="@/assets/img/loading.svg" />
			<span class="text">{{statusText}}...</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			// 状态值
			statusText: {
				type: String,
				default: ''
			}
		}
	}
</script>

<style lang="scss" scoped>
	.loading {
		.skeleton {
			height: 3px;
			border-radius: 1px;
			margin-bottom: 5px;
			animation-name: sk-loading;
			animation-duration: 1.4s;
			animation-timing-function: ease-out;
			animation-iteration-count: infinite;

			&.sk-70 {
				width: 70%;
			}

			&.sk-20 {
				width: 20%;
			}

			@keyframes sk-loading {
				0% {
					background: #8D8D88;
				}

				50% {
					background: #d1d1d1;
				}

				100% {
					background: #8D8D88;
				}
			}
		}
		
		.status-text{
			display: flex;
			align-items: center;
			font-size: 13px;
			.text{
				margin: 0 0 0 6px;
			}
		}
	}
	
	.icon-rorate{
		width: 20px;
		height: 20px;
		animation: rotate 2s linear infinite;
	}
	@keyframes rotate {  
	  0% {  
	    transform: rotate(0deg);  
	  }  
	  100% {  
	    transform: rotate(360deg);  
	  }  
	}  
</style>



// WEBPACK FOOTER //
// src/views/layout/aiAssistent/aiAssistentLoading.vue